"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSelectedOrgId = exports.setLoggedInToken = exports.removeSelectedOrgId = exports.isNewLoggedInSession = exports.getSelectedOrgId = exports.getLoginToken = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DOMAIN = '.collegeboard.org';
var ORGID_COOKIE = 'apfymSelectedOrgId';
var LOGGEDIN_COOKIE = 'apfymLoggedInToken';
var getLoginToken = function getLoginToken() {
  return _jsCookie.default.get('cb_login');
};
exports.getLoginToken = getLoginToken;
var setSelectedOrgId = function setSelectedOrgId(orgId) {
  var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DOMAIN;
  if (orgId) _jsCookie.default.set(ORGID_COOKIE, orgId, {
    domain: domain
  });
};
exports.setSelectedOrgId = setSelectedOrgId;
var getSelectedOrgId = function getSelectedOrgId() {
  var orgId = _jsCookie.default.get(ORGID_COOKIE);
  return orgId ? parseInt(orgId, 10) : null;
};
exports.getSelectedOrgId = getSelectedOrgId;
var removeSelectedOrgId = function removeSelectedOrgId() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DOMAIN;
  return _jsCookie.default.remove(ORGID_COOKIE, {
    domain: domain
  });
};
exports.removeSelectedOrgId = removeSelectedOrgId;
var setLoggedInToken = function setLoggedInToken() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DOMAIN;
  return _jsCookie.default.set(LOGGEDIN_COOKIE, getLoginToken(), {
    domain: domain
  });
};
exports.setLoggedInToken = setLoggedInToken;
var isNewLoggedInSession = function isNewLoggedInSession() {
  return _jsCookie.default.get(LOGGEDIN_COOKIE) !== getLoginToken();
};
exports.isNewLoggedInSession = isNewLoggedInSession;